// extracted by mini-css-extract-plugin
export default {"container":"styles_container__9FhD5","header":"styles_header__UzHIn","body":"styles_body__OIX3x"};